<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="d-flex flex-column">
        <b-row class="sa-label-info">
          <b-col lg="3">
            <p>Record Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <div class="sa-flexbox-body">
        <div class="b-table-sticky-header">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
            <template #cell(index)="row">
              {{ (currentPage - 1) * perPage + row.index + 1 }}
            </template>
            <template #cell(paziente)="row">
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center"> {{ row.item.cognome }} {{ row.item.nome }}</span>
              <span style="font-weight: 400; display: flex; width: 100%; justify-content: start; align-items: center"> ({{ row.item.identificativo }}) </span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{ getData(row.item.dataNascita) }} </span>
            </template>
            <template #cell(ricovero)="row">
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">I. : {{ getData(row.item.dataRicovero) }}</span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">F. : {{ getData(row.item.dataDimissioneTrasferimento) }}</span>
            </template>
            <template #cell(struttura)="row">
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{ row.item.strutturaDenominazione }}({{ row.item.strutturaCodice }})</span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{ row.item.presidioDenominazione }}({{ row.item.presidioCodice }})</span>
            </template>
            <template #cell(localita)="row">
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center"> {{ row.item.aslAppartenenza }} </span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center"> {{ row.item.comuneAppartenenza }}</span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{ row.item.distrettoAppartenenza }} </span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center"> {{ row.item.ambitoAppartenenza }} </span>
            </template>
            <template #cell(impegnativa)="row">
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{ row.item.numeroAutorizzazioneImpegnativa }}</span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{ getData(row.item.dataAutorizzazioneImpegnativa) }}</span>
              <span style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{ getData(row.item.dataScadenzaImpegnativa) }} </span>
            </template>
            >
            <template v-slot:cell(actions)="{ item }">
              <b-container class="bv-example-row">
                <b-button size="sm" v-b-tooltip.hover title="Visualizza Soggetto" variant="outline-secondary" @click="onClickViewSoggetto(item)">
                  <font-awesome-icon icon="eye"> </font-awesome-icon>
                </b-button>
              </b-container>
            </template>
          </b-table>
        </div>
        <!-- <contabilita-documento-soggetto-modal-edit-component ref="cmpSoggettoModalEdit" @saveSoggetto="loadDataSoggetti" @soggettoDelete="loadDataSoggetti" @onCloseModal="loadDataSoggetti" /> -->
      </div>
      <div class="sa-list-component-footer">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Record Totali:{{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import moment from "moment";
export default {
  mixins: [UtilityMixin],
  components: {},
  props: {},
  data() {
    return {
      rows: 0,
      perPage: 50,
      currentPage: 1,
      listKey: 0,
      pathResource: "/rsapazientepresenze/riepilogo",
      btnAggiungi: false,
      idAccettazione: "",
      items: [],
      presidio: null,
      isDynamicFormView: true,
      dynamicJsonData: {},
      defaultValues: {},
      jsonDataAccettazione: {},
      filtroRiepilogoPresenze: {},
      fields: [
        { key: "paziente", label: "Paziente", thStyle: "width: 15rem" },
        { key: "localita", label: "Localita", thStyle: "width: 35rem" },

        {
          key: "struttura",
          label: "Struttura e Presidio",
          thStyle: "width: 35rem",
        },
        {
          key: "ricovero",
          label: "Ricovero",
        },
        { key: "giorniPresenza", label: "Giorni Presenza" },
        { key: "numeroGiorniAssenza", label: "Num. Giorni di Assenza" },
        { key: "giorniAssenza", label: "Giorni Assenza" },
        { key: "impegnativa", label: "Impegnativa" },
        // { key: "giorniAssenza", label: "Giorni Assenza" },
      ],
    };
  },
  watch: {},
  mounted() {
    this.setPresidio();
  },
  methods: {
    init() {
      // let me = this;
      // me.loadData();
    },
    getData(value) {
      if (value) {
        return moment(new Date(value)).format("DD/MM/YYYY");
      } else {
        return "----";
      }
    },
    loadData(filtro) {
      let me = this;
      this.$emit("beforeLoadData");
      if (sessionStorage["filterRiepilogo"]) {
        me.filtro = JSON.parse(sessionStorage["filterRiepilogo"]);
      }
      me.filtroRiepilogoPresenze.dataDal = filtro.dataDal;
      me.filtroRiepilogoPresenze.dataAl = filtro.dataAl;
      me.filtroRiepilogoPresenze.page = me.currentPage;
      me.filtroRiepilogoPresenze.forPage = me.perPage;
      me.filtroRiepilogoPresenze.idPresidio = this.presidio.id;
      if (me.filtroRiepilogoPresenze.idPresidio == null) {
        this.$bvToast.toast("Presidio Obbligatorio!", {
          title: "Attenzione!",
          autoHideDelay: 5000,
          variant: "danger",
        });
        return;
      }

      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroRiepilogoPresenze, me.loadDataSuccess, me.loadDataError);
    },
    setPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        this.presidio = JSON.parse(tmpPresidio);
      }
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data;
      me.rows = response.data.data.length;
      this.setPresidio();
      me.$emit("afterLoadData", me.items);
    },
    loadDataError(error) {
      let me = this;
      this.errorToast(error.response.data.messaggio);
      me.$emit("afterLoadData");
    },
  },
};
</script>

<style lang="scss" scoped></style>
